/*
 * List of types for Generic Reducer and Actions
 */

export const erpTypes = {
  ERP_API: 'ERP_API',
  CHANGE_PACK: 'CHANGE_PACK',
  CHANGE_PERMISSIONS: 'CHANGE_CURRENT_PERMISSIONS',
  CHANGE_OWNER: 'CHANGE_OWNER',
  LOAD_COMPANY_DATA: 'LOAD_COMPANY_DATA',
  OPEN_MODAL_PACK: 'OPEN_MODAL_PACK',
  IS_PERMISSION_VALID: 'IS_PERMISSION_VALID',
  OPEN_MODAL_PERMISSION: 'OPEN_MODAL_PERMISSION',
  CHANGE_PRO_FEATURE: 'CHANGE_PRO_FEATURE',
}
